export class ResourcesMapping {
  resource_name: string;
  column: string;
  display: string;
}
